export enum HtmlStringFormatterBlock {
  Root = 'HtmlStringFormatter',
}
